import React from "react"
// import NO_DATA from "assets/images/search-not-found.png"
import { useTranslation } from "react-i18next"
import { CgSearchLoading } from "react-icons/cg"

export default ({ message }) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-center w-full h-full p-4 text-black py-14">
      <div className="flex flex-col items-center justify-center gap-4 ">
        {/* <img src={NO_DATA} alt="no__image" className="md:w-[800px] w-[200px]" /> */}
        <CgSearchLoading color="#000" size={90} />
        <div className="font-semibold text-center text-black md:text-3xl lg:text-xl">
          {t(message)}!
        </div>
      </div>
    </div>
  )
}
